import app from 'flarum/forum/app';

import config from '../common/config';

app.initializers.add(config.module.key, () => {});
